import { render, staticRenderFns } from "./EmergencyMaterialDialog.vue?vue&type=template&id=2e4a4fc8&scoped=true"
import script from "./EmergencyMaterialDialog.vue?vue&type=script&lang=js"
export * from "./EmergencyMaterialDialog.vue?vue&type=script&lang=js"
import style0 from "./EmergencyMaterialDialog.vue?vue&type=style&index=0&id=2e4a4fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a4fc8",
  null
  
)

export default component.exports